import * as React from 'react';
import CustomHeader from '../components/CustomHeader';
import CustomParagraph from '../components/CustomParagraph';
import logo from '../assets/Images/logo.png';
import cseLogo from '../assets/Images/cse_logo.png';

const About = () => {
  return (
    <div
      id="about"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ padding: "20px", maxWidth: "70%" }}>
        <CustomHeader value="About" />
      </div>

      <div
        style={{
          padding: "20px",
          maxWidth: "70%",
          display: "flex",
          justifyContent: "center",
          paddingBottom: "40px",
          gap: "20px",
        }}
      >
        <img
          src={logo}
          alt="Logo"
          style={{
            width: "50%",
            maxWidth: 450,
            maxHeight: 150,
            margin: "auto",
          }}
        />
        <img
          src={cseLogo}
          alt="CseLogo"
          style={{
            width: "50%",
            maxWidth: 350,
            maxHeight: 200,
            margin: "auto",
          }}
        />
      </div>
      <div
        style={{
          padding: "20px",
          maxWidth: "70%",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          alignItems: "center",
        }}
      >
        <CustomParagraph />
      </div>
    </div>
  );
};

export default About;